__turbopack_context__.v({
  "badge": "isLiveBadge-module__zA1TYa__badge",
  "icon": "isLiveBadge-module__zA1TYa__icon",
});
